import { render, staticRenderFns } from "./MenusBackoffice.vue?vue&type=template&id=107d94d9"
import script from "./MenusBackoffice.vue?vue&type=script&lang=js"
export * from "./MenusBackoffice.vue?vue&type=script&lang=js"
import style0 from "./MenusBackoffice.vue?vue&type=style&index=0&id=107d94d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports